import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import BankingInfo from './BankingInfo';

class Banking extends Component {
  render() {
    return (
      <Query
        query={gql`
          {
            currentUser {
              id
              transitNumber
              bankName
              routingNumber
              institutionNumber
              accountNumber
              hstNumber
              operatingCity
            }
          }
        `}>
        {({ loading, error, data, refetch }) => {
          if (loading) return null;
          if (error) return <Redirect to="/404" />;
          return <BankingInfo refetch={refetch} currentUser={data.currentUser} />;
        }}
      </Query>
    );
  }
}
export default Banking;



// WEBPACK FOOTER //
// ./src/components/Banking/index.js